var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "container-fluid compras-outros-page"
  }, [_c('div', {
    staticClass: "card-body h-100"
  }, [_c('b-card', [_c('b-tabs', {
    staticClass: "compras-outros-tabs",
    attrs: {
      "pills": "",
      "vertical": "",
      "nav-wrapper-class": "w-25"
    }
  }, [_c('b-tab', {
    attrs: {
      "title": "Informações fiscais",
      "active": _vm.store.currentTab === 0,
      "disabled": _vm.store.currentTab !== 0
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "5"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Modelo",
      "label-for": "model"
    }
  }, [_c('b-form-select', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: _vm.form.modeloNFe,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "modeloNFe", $$v);
      },
      expression: "form.modeloNFe"
    }
  }, _vm._l(_vm.models, function (model) {
    return _c('b-form-select-option', {
      key: model.modelo,
      attrs: {
        "value": model.modelo
      }
    }, [_vm._v(" " + _vm._s(model.descricao) + " ")]);
  }), 1)], 1)], 1), _c('b-col', {
    attrs: {
      "md": "5"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Natureza",
      "label-for": "natureza"
    }
  }, [_c('VueSelect', {
    ref: "buscarNatureza",
    class: {
      hasErrors: _vm.naturezaError
    },
    attrs: {
      "filterable": false,
      "options": _vm.naturezas
    },
    on: {
      "input": _vm.setNatureza,
      "search": _vm.onSearchCFOP
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-center"
        }, [_vm._v(" " + _vm._s(option.descricao) + " ")])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.descricao) + " ")])];
      }
    }]),
    model: {
      value: _vm.natureza,
      callback: function callback($$v) {
        _vm.natureza = $$v;
      },
      expression: "natureza"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe o código da Natureza ")])], 2)], 1)], 1), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "CFOP",
      "label-for": "cfop"
    }
  }, [_c('b-form-input', {
    attrs: {
      "disabled": "",
      "id": "cfop",
      "name": "cfop"
    },
    model: {
      value: _vm.cfop,
      callback: function callback($$v) {
        _vm.cfop = $$v;
      },
      expression: "cfop"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "7"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "chaveDeAcesso",
      "label-for": "chaveDeAcesso",
      "label": "Chave"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "chaveDeAcesso",
      "name": "chaveDeAcesso"
    },
    model: {
      value: _vm.form.chaveDeAcesso,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "chaveDeAcesso", $$v);
      },
      expression: "form.chaveDeAcesso"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "numeroNFe",
      "label-for": "numeroNFe",
      "label": "Número"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "numeroNFe",
      "name": "numeroNFe",
      "maxlength": "10",
      "state": _vm.validateState('numeroNFe')
    },
    model: {
      value: _vm.$v.form.numeroNFe.$model,
      callback: function callback($$v) {
        _vm.$set(_vm.$v.form.numeroNFe, "$model", $$v);
      },
      expression: "$v.form.numeroNFe.$model"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "serieNFe",
      "label-for": "serieNFe",
      "label": "Série"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "serieNFe",
      "name": "serieNFe",
      "maxlength": "5",
      "state": _vm.validateState('serieNFe')
    },
    model: {
      value: _vm.$v.form.serieNFe.$model,
      callback: function callback($$v) {
        _vm.$set(_vm.$v.form.serieNFe, "$model", $$v);
      },
      expression: "$v.form.serieNFe.$model"
    }
  })], 1)], 1)], 1)], 1), _c('b-tab', {
    attrs: {
      "title": "Fornecedor",
      "active": _vm.store.currentTab === 1,
      "disabled": _vm.store.currentTab !== 1
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Fornecedor",
      "label-for": "fornecedor"
    }
  }, [_c('VueSelect', {
    ref: "buscarFornecedor",
    attrs: {
      "filterable": false,
      "options": _vm.fornecedores
    },
    on: {
      "input": _vm.setFornecedor,
      "search": _vm.onSearchFornecedor
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-center"
        }, [_vm._v(" " + _vm._s(option.nome) + " ")])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.nome) + " ")])];
      }
    }]),
    model: {
      value: _vm.fornecedor,
      callback: function callback($$v) {
        _vm.fornecedor = $$v;
      },
      expression: "fornecedor"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe o nome do Fornecedor ")])], 2)], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "dataEmissao",
      "label-for": "dataEmissao",
      "label": "Data Emissão"
    }
  }, [_c('b-form-datepicker', {
    attrs: {
      "state": _vm.validateState('dataEmissao'),
      "locale": "pt-br",
      "date-format-options": {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric'
      }
    },
    model: {
      value: _vm.$v.form.dataEmissao.$model,
      callback: function callback($$v) {
        _vm.$set(_vm.$v.form.dataEmissao, "$model", $$v);
      },
      expression: "$v.form.dataEmissao.$model"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "dataEntrada",
      "label-for": "dataEntrada",
      "label": "Data Entrada"
    }
  }, [_c('b-form-datepicker', {
    attrs: {
      "state": _vm.validateState('dataEntrada'),
      "locale": "pt-br",
      "date-format-options": {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric'
      }
    },
    model: {
      value: _vm.$v.form.dataEntrada.$model,
      callback: function callback($$v) {
        _vm.$set(_vm.$v.form.dataEntrada, "$model", $$v);
      },
      expression: "$v.form.dataEntrada.$model"
    }
  })], 1)], 1)], 1)], 1), _c('b-tab', {
    attrs: {
      "title": "Valores Totais",
      "active": _vm.store.currentTab === 2,
      "disabled": _vm.store.currentTab !== 2
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "valor-total",
      "label-for": "valor-total",
      "label": "Total Nota"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    model: {
      value: _vm.formImpostos.totalProdutos,
      callback: function callback($$v) {
        _vm.$set(_vm.formImpostos, "totalProdutos", $$v);
      },
      expression: "formImpostos.totalProdutos"
    }
  }, 'money', _vm.configMoney, false))], 1)], 1), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "base-icms",
      "label-for": "base-icms",
      "label": "Base de Cálculo"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    model: {
      value: _vm.formImpostos.icmsBase,
      callback: function callback($$v) {
        _vm.$set(_vm.formImpostos, "icmsBase", $$v);
      },
      expression: "formImpostos.icmsBase"
    }
  }, 'money', _vm.configMoney, false))], 1)], 1), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "valor-icms",
      "label-for": "valor-icms",
      "label": "Valor ICMS"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    model: {
      value: _vm.formImpostos.icmsValue,
      callback: function callback($$v) {
        _vm.$set(_vm.formImpostos, "icmsValue", $$v);
      },
      expression: "formImpostos.icmsValue"
    }
  }, 'money', _vm.configMoney, false))], 1)], 1), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "outrasDespesas",
      "label-for": "outrasDespesas",
      "label": "Outras"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    model: {
      value: _vm.formImpostos.outrasDespesas,
      callback: function callback($$v) {
        _vm.$set(_vm.formImpostos, "outrasDespesas", $$v);
      },
      expression: "formImpostos.outrasDespesas"
    }
  }, 'money', _vm.configMoney, false))], 1)], 1)], 1)], 1), _c('b-tab', {
    attrs: {
      "title": "Pagamento",
      "active": _vm.store.currentTab === 3,
      "disabled": _vm.store.currentTab !== 3
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Forma de Pagamento",
      "label-for": "formaPagamento"
    }
  }, [_c('VueSelect', {
    ref: "buscaPagamentos",
    staticClass: "busca-cliente",
    attrs: {
      "label": "descricao",
      "id": "buscaPagamentos",
      "options": _vm.pagamentos
    },
    on: {
      "input": _vm.changePagamentos
    },
    model: {
      value: _vm.pagamento,
      callback: function callback($$v) {
        _vm.pagamento = $$v;
      },
      expression: "pagamento"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "numero",
      "label-for": "numero",
      "label": "Valor R$"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "id": "valorPagamento",
      "name": "valorPagamento",
      "value": _vm.valorPgto
    }
  }, 'money', _vm.configMask, false))], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Plano de contas",
      "label-for": "buscar_planos"
    }
  }, [_c('VueSelect', {
    ref: "buscar_planos",
    attrs: {
      "filterable": false,
      "placeholder": "Seleciona um plano de contas",
      "options": _vm.plano_contas
    },
    on: {
      "input": _vm.setPlanoContas,
      "search": _vm.onSearchPlano
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-center"
        }, [_vm._v(" " + _vm._s(option.descricao) + " ")])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.descricao) + " ")])];
      }
    }]),
    model: {
      value: _vm.planoContasSelecionado,
      callback: function callback($$v) {
        _vm.planoContasSelecionado = $$v;
      },
      expression: "planoContasSelecionado"
    }
  })], 1), _c('CentroCustoSelect', {
    model: {
      value: _vm.form.id_centro_custo,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "id_centro_custo", $$v);
      },
      expression: "form.id_centro_custo"
    }
  })], 1)], 1), _c('b-row', [_vm.listaPagamentos.length > 0 ? _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-col', {
    staticClass: "busca"
  }, [_c('TableApp', {
    ref: "valor",
    attrs: {
      "item": "pagamento",
      "subTitulo": "",
      "data": _vm.listaPagamentos[0].range,
      "fields": _vm.fields,
      "classFilterColumn": "valor"
    },
    scopedSlots: _vm._u([{
      key: "customRow",
      fn: function fn(props) {
        return [props.field == 'id' ? _c('span', {
          staticClass: "pl-0 pt-8",
          attrs: {
            "slot": "nome"
          },
          slot: "nome"
        }, [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('div', {
          staticClass: "font-weight-bold text-muted"
        }, [_vm._v(" " + _vm._s(props.rowData.originalIndex + 1) + " ")])])]) : _vm._e(), props.field == 'valor' ? _c('span', {
          staticClass: "pl-0 pt-8",
          attrs: {
            "slot": "nome"
          },
          slot: "nome"
        }, [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('div', {
          staticClass: "font-weight-bold text-muted cursor-pointer",
          on: {
            "click": function click($event) {
              return _vm.changePagamento(props.rowData.originalIndex, props.rowData.value);
            }
          }
        }, [_vm._v(" " + _vm._s(_vm.numberToReal(props.rowData.value, 2)) + " ")])])]) : _vm._e(), props.field == 'vencimento' ? _c('span', {
          staticClass: "pl-0 pt-8",
          attrs: {
            "slot": "quantidade"
          },
          slot: "quantidade"
        }, [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('div', {
          staticClass: "font-weight-bold text-muted cursor-pointer",
          on: {
            "click": function click($event) {
              return _vm.selectVencimento(props.rowData.originalIndex, props.rowData.date);
            }
          }
        }, [_vm._v(" " + _vm._s(_vm._f("moment")(props.rowData.date, "DD/MM/YYYY")) + " ")])])]) : _vm._e()];
      }
    }], null, false, 1389378444)
  })], 1)], 1) : _vm._e()], 1), _c('b-row', [_c('b-col', [_c('button', {
    ref: "addPagamento",
    staticClass: "btn btn-secondary font-weight-bold mb-10",
    on: {
      "click": _vm.adicionarPagamento
    }
  }, [_vm._v(" + Adicionar Pagamento ")])])], 1), _c('b-row', [_c('b-col', [_c('TableApp', {
    ref: "formaPagamento",
    staticClass: "mt-10",
    attrs: {
      "item": "pagamento",
      "titulo": "Pagamentos",
      "data": _vm.listaPagamentos,
      "fields": _vm.fieldsPagamentosRealizados,
      "classFilterColumn": "formaPagamento"
    },
    scopedSlots: _vm._u([{
      key: "customRow",
      fn: function fn(props) {
        return [props.field == 'forma_pagamento' ? _c('span', {
          staticClass: "pl-0 pt-8",
          attrs: {
            "slot": "nome"
          },
          slot: "nome"
        }, [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('div', {
          staticClass: "font-weight-bold text-muted"
        }, [_vm._v(" " + _vm._s(props.rowData.descricao) + " ")])])]) : _vm._e(), props.field == 'valor' ? _c('span', {
          staticClass: "pl-0 pt-8",
          attrs: {
            "slot": "quantidade"
          },
          slot: "quantidade"
        }, [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('div', {
          staticClass: "font-weight-bold text-muted"
        }, [_vm._v(" R$ " + _vm._s(_vm.numberToReal(props.rowData.value, 2)) + " ")])])]) : _vm._e(), props.field == 'actions' ? _c('span', {
          attrs: {
            "slot": "actions"
          },
          slot: "actions"
        }, [_c('div', {
          staticClass: "row-actions",
          staticStyle: {
            "text-align": "right !important"
          }
        }, [_c('span', {
          staticStyle: {
            "overflow": "visible",
            "position": "relative",
            "width": "130px"
          }
        }, [_c('div', {
          staticClass: "action-buttons"
        }, [_c('button', {
          staticClass: "btn btn-sm btn-danger btn-hover-danger btn-icon mr-2",
          on: {
            "click": function click($event) {
              return _vm.removePagamento(props.rowData, props.rowData.originalIndex);
            }
          }
        }, [_c('TrashCanIcon', {
          attrs: {
            "size": 16
          }
        })], 1)])])])]) : _vm._e()];
      }
    }])
  })], 1)], 1)], 1)], 1)], 1), _c('div', {
    staticClass: "card-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm.canSaveCompra ? _c('div', [_c('button', {
    staticClass: "btn btn-secondary font-weight-bold mr-4",
    attrs: {
      "disabled": _vm.store.currentTab === 0
    },
    on: {
      "click": _vm.handlePrevious
    }
  }, [_vm._v(" Anterior ")]), _c('button', {
    ref: "submit_nova_compra",
    staticClass: "btn btn-primary font-weight-bold",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.salvarCompra
    }
  }, [_vm._v(" Salvar ")]), _c('router-link', {
    staticClass: "btn btn-clean font-weight-bold",
    attrs: {
      "to": {
        name: 'comprasLista'
      }
    }
  }, [_vm._v(" Cancelar ")])], 1) : _c('div', [_c('button', {
    staticClass: "btn btn-secondary font-weight-bold mr-4",
    attrs: {
      "disabled": _vm.store.currentTab === 0
    },
    on: {
      "click": _vm.handlePrevious
    }
  }, [_vm._v(" Anterior ")]), _c('button', {
    staticClass: "btn btn-primary font-weight-bold",
    attrs: {
      "disabled": _vm.store.currentTab === 7
    },
    on: {
      "click": _vm.handleNext
    }
  }, [_vm._v(" Proximo ")]), _c('router-link', {
    staticClass: "btn btn-clean font-weight-bold",
    attrs: {
      "to": {
        name: 'comprasLista'
      }
    }
  }, [_vm._v(" Cancelar ")])], 1)])])])], 1), _c('b-modal', {
    attrs: {
      "id": "modal-calendar",
      "title": "Ajustar vencimento",
      "size": "sm",
      "centered": ""
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref) {
        var ok = _ref.ok,
          cancel = _ref.cancel;
        return [_c('b-button', {
          on: {
            "click": function click($event) {
              return cancel();
            }
          }
        }, [_vm._v(" Cancelar ")]), _c('b-button', {
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": _vm.salvarVencimento
          }
        }, [_vm._v(" Salvar ")])];
      }
    }])
  }, [_c('div', {
    staticClass: "mx-auto"
  }, [_c('b-calendar', {
    attrs: {
      "locale": "pt-BR"
    },
    model: {
      value: _vm.vencimentoSelected,
      callback: function callback($$v) {
        _vm.vencimentoSelected = $$v;
      },
      expression: "vencimentoSelected"
    }
  })], 1)]), _c('b-modal', {
    attrs: {
      "id": "modal-pagamento",
      "title": "Ajustar pagamento",
      "size": "sm",
      "centered": ""
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref2) {
        var ok = _ref2.ok,
          cancel = _ref2.cancel;
        return [_c('b-button', {
          on: {
            "click": function click($event) {
              return cancel();
            }
          }
        }, [_vm._v(" Cancelar ")]), _c('b-button', {
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": _vm.salvarPagamento
          }
        }, [_vm._v(" Salvar ")])];
      }
    }])
  }, [_c('div', {
    staticClass: "mx-auto"
  }, [_c('b-form', {
    staticClass: "form",
    on: {
      "submit": function submit($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.salvarPagamento.apply(null, arguments);
      }
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "id": "valorPagamento",
      "name": "valorPagamento",
      "value": _vm.pagamentoSelected
    },
    on: {
      "input": _vm.changePagamentoEdited
    }
  }, 'money', _vm.configMoney, false))], 1)], 1)])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };